import React from 'react';

interface ITextAreaProps {
  customClasses?: string;
  name: string;
  value: any;
  cols?: number;
  rows?: number;
  onChange?: any;
  placeholder?: string;
  resize?: boolean;
  disabled?: boolean;
}

export const TextArea: React.FC<ITextAreaProps> = ({
  customClasses = '',
  value,
  name,
  onChange,
  cols,
  rows,
  placeholder,
  disabled,
  resize,
}: ITextAreaProps) => {
  return (
    <textarea
      className={`form-control ${customClasses}`}
      name={name}
      cols={cols}
      rows={rows}
      value={value}
      disabled={disabled}
      onChange={onChange}
      placeholder={placeholder}
      style={{ resize: !resize ? 'none' : undefined }}
    />
  );
};

TextArea.defaultProps = {
  customClasses: '',
  placeholder: '',
  resize: true,
  cols: 30,
  rows: 5,
  disabled: false,
  onChange: () => {},
};
